declare namespace $ {

	export class $mol_icon_card extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=card.view.tree.d.ts.map